import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./CommonDatePicker.css";

function CommonDatePicker({
  value,
  onChange,
  placeholder = "날짜 선택",
  name,
  showTime = false,
  minDate,
  maxDate,
  useButton = false,   //  버튼 모드 여부
  buttonLabel = "선택", //  버튼 모드일 때 표시할 텍스트
  onSelectDate,        //  선택 후 콜백
  ...props
}) {
  // 버튼 모드일 때 사용할 커스텀 버튼
  const CustomButton = React.forwardRef(({ onClick }, ref) => (
    <button className="btn btn-outline-primary" onClick={onClick} ref={ref}>
      {buttonLabel}
    </button>
  ));

  // react-datepicker는 minTime 사용 시 maxTime이 필수이고 그 반대도 마찬가지입니다.
  // 한쪽만 전달될 경우 발생할 수 있는 런타임 에러를 방지하기 위해 보정 로직을 추가합니다.
  const finalProps = { ...props };
  if (finalProps.minTime && !finalProps.maxTime) {
    const d = new Date(finalProps.minTime);
    d.setHours(23, 59, 59);
    finalProps.maxTime = d;
  }
  if (finalProps.maxTime && !finalProps.minTime) {
    const d = new Date(finalProps.maxTime);
    d.setHours(0, 0, 0);
    finalProps.minTime = d;
  }

  return (
    <DatePicker
      selected={value}
      onChange={(date) => {
        onChange(date);       // 기존 상태 업데이트
        if (onSelectDate) {   // 추가 콜백 실행
          onSelectDate(date);
        }
      }}
      className={!useButton ? "form-control" : undefined}
      placeholderText={placeholder}
      name={name}
      dateFormat={showTime ? "yyyy-MM-dd HH:mm" : "yyyy-MM-dd"}
      showTimeSelect={showTime}
      timeFormat="HH:mm"
      timeIntervals={30}
      minDate={minDate}
      maxDate={maxDate}
      customInput={useButton ? <CustomButton /> : undefined}
      {...finalProps}
    />
  );
}

export default CommonDatePicker;